if (!customElements.get('blog-carousel')) {
  class BlogCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.science-carousel__track');
      this.scrollbarThumb = this.querySelector('.science-carousel__scrollbar-thumb');
      if (!this.track || !this.scrollbarThumb) return;

      const update = () => {
        const trackWidth = this.track.clientWidth;
        const scrollWidth = this.track.scrollWidth;
        if (!scrollWidth) return;
        const ratio = Math.min(1, trackWidth / scrollWidth);
        const maxScroll = scrollWidth - trackWidth;
        const progress = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
        this.scrollbarThumb.style.width = ratio * 100 + '%';
        this.scrollbarThumb.style.left = progress * (1 - ratio) * 100 + '%';
      };

      this.track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  customElements.define('blog-carousel', BlogCarousel);
}
